<template>
<div class="monitor-container">
    <Row type="flex" :gutter="9">
        <Col flex="1" >
        <Card class="card-container" dis-hover>
            <!--安全防护-->
            <div slot="title" class="card-title">{{ getTranslation('a114') }}</div>
            <Row type="flex" class="normal-hover" >
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('r041') }}</div>
                    </Col>
                    <Col flex="1" >
                        <i-switch class="switch-cls" size="large" :true-value="1" :false-value="0"  ></i-switch>
                    </Col>
                </Row>
                </Col>
            </Row>
            <Row type="flex" class="normal-hover multi-row" >
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a120') }}</div>
                    </Col>
                    <Col flex="1" >
                        <i-switch class="switch-cls" size="large" :true-value="1" :false-value="0" v-model="HwAssy0bit6"></i-switch>
                    </Col>
                </Row>
                </Col>
            </Row>
            <Row type="flex" class="normal-hover multi-row">
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a121') }}</div>
                    </Col>
                    <Col flex="1" >
                        <i-switch class="switch-cls" size="large" :true-value="1" :false-value="0" v-model="HwAssy0bit4" ></i-switch>
                    </Col>
                </Row>
                </Col>
            </Row>
            <Row type="flex" class="normal-hover multi-row">
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a122') }}</div>
                    </Col>
                    <Col flex="1" >
                        <i-switch class="switch-cls" size="large" :true-value="1" :false-value="0" v-model="HwAssy0bit0"></i-switch>
                    </Col>
                </Row>
                </Col>
            </Row>
            <Row type="flex" class="normal-hover multi-row">
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a123') }}</div>
                    </Col>
                    <Col flex="1" >
                        <i-switch class="switch-cls" size="large" :true-value="1" :false-value="0" v-model="HwAssy0bit9"></i-switch>
                    </Col>
                </Row>
                </Col>
            </Row>
            <Row type="flex" class="normal-hover multi-row">
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a124') }}</div>
                    </Col>
                    <Col flex="1" >
                        <i-switch class="switch-cls" size="large" :true-value="1" :false-value="0" v-model="HwAssy0bit2"> </i-switch>
                    </Col>
                </Row>
                </Col>
            </Row>
            <Row type="flex" class="normal-hover multi-row">
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a125') }}</div>
                    </Col>
                    <Col flex="1" >
                        <i-switch class="switch-cls" size="large" :true-value="1" :false-value="0" v-model="HwAssy0bit1"> </i-switch>
                    </Col>
                </Row>
                </Col>
            </Row>
        </Card>
        </Col>

        <Col flex="1" >
        <Card class="card-container" dis-hover>
            <div slot="title" class="card-title">{{ getTranslation('a126') }}</div>
            <Row type="flex" class="normal-hover">
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('c015') }}</div>
                    </Col>
                    <Col flex="1" >
                        <i-switch class="switch-cls" size="large" :true-value="1" :false-value="0"></i-switch>
                    </Col>
                </Row>
                </Col>
            </Row>
            <Row type="flex" class="normal-hover multi-row" >
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a127') }}</div>
                    </Col>
                    <Col flex="1" >
                        <i-switch class="switch-cls" size="large" :true-value="1" :false-value="0" v-model="HwAssy1bit13"></i-switch>
                    </Col>
                </Row>
                </Col>
            </Row>
             <Row type="flex" class="normal-hover multi-row" >
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a128') }}</div>
                    </Col>
                    <Col flex="1" >
                        <i-switch class="switch-cls" size="large" :true-value="1" :false-value="0" v-model="HwAssy1bit14"></i-switch>
                    </Col>
                </Row>
                </Col>
            </Row>
             <Row type="flex" class="normal-hover multi-row" >
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a129') }}</div>
                    </Col>
                    <Col flex="1" >
                        <i-switch class="switch-cls" size="large" :true-value="1" :false-value="0" v-model="HwAssy1bit15"></i-switch>
                    </Col>
                </Row>
                </Col>
            </Row>

            <Row type="flex" class="normal-hover multi-row" >
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a036') }}</div>
                    </Col>
                    <Col flex="1" >
                        <i-switch class="switch-cls" size="large" :true-value="1" :false-value="0" ></i-switch>
                    </Col>
                </Row>
                </Col>
            </Row>
            <Row type="flex" class="normal-hover multi-row" >
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a037') }}</div>
                    </Col>
                    <Col flex="1" >
                        <i-switch class="switch-cls" size="large" :true-value="1" :false-value="0" ></i-switch>
                    </Col>
                </Row>
                </Col>
            </Row>
            <Row type="flex" class="normal-hover multi-row" >
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a035') }}</div>
                    </Col>
                    <Col flex="1" >
                        <i-switch class="switch-cls" size="large" :true-value="1" :false-value="0" ></i-switch>
                    </Col>
                </Row>
                </Col>
            </Row>
            
        </Card>
        </Col>

        <Col flex="1" >
        <Card class="card-container" dis-hover>
            <div slot="title" class="card-title">{{ getTranslation('a130') }}</div>
            <Row type="flex" class="normal-hover multi-row">
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a131') }}</div>
                    </Col>
                    <Col flex="1" >
                        <i-switch class="switch-cls" size="large" :true-value="1" :false-value="0" v-model="HwAssy1bit10"></i-switch>
                    </Col>
                </Row>
                </Col>
            </Row>
            <Row type="flex" class="normal-hover multi-row">
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a132') }}</div>
                    </Col>
                    <Col flex="1" >
                        <Select :transfer="true" class="input-field" size="small" v-model="localData.HwE1PropValveType"
                        :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                        <Option v-for="(item, key) in PropValveTypeLisdt" :value="key" :key="key">{{ item }}</Option>
                        </Select>
                    </Col>
                </Row>
                </Col>
            </Row>
            <Row type="flex" class="normal-hover multi-row">
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a133') }}</div>
                    </Col>
                    <Col flex="1" >
                        <Select :transfer="true" class="input-field" size="small" v-model="localData.HwValveTypePrePrs"
                        :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                        <Option v-for="(item, key) in ValveTypePrePrsList" :value="key" :key="key">{{ item }}</Option>
                        </Select>
                    </Col>
                </Row>
                </Col>
            </Row>

            <Row type="flex" class="normal-hover multi-row">
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a134') }}</div>
                    </Col>
                    <Col flex="1" >
                        <i-switch class="switch-cls" size="large" :true-value="1" :false-value="0"></i-switch>
                    </Col>
                </Row>
                </Col>
            </Row>

            <Row type="flex" class="normal-hover multi-row">
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a135') }}</div>
                    </Col>
                    <Col flex="1" >
                        <i-switch class="switch-cls" size="large" :true-value="1" :false-value="0"></i-switch>
                    </Col>
                </Row>
                </Col>
            </Row>
             <Row type="flex" class="normal-hover multi-row">
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a136') }}</div>
                    </Col>
                    <Col flex="1" >
                        <Select :transfer="true" class="input-field" size="small" v-model="localData.HwValveTypeTrip"
                        :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                        <Option v-for="(item, key) in ValveTypePrePrsList" :value="key" :key="key">{{ item }}</Option>
                        </Select>
                    </Col>
                </Row>
                </Col>
            </Row>

            <Row type="flex" class="normal-hover multi-row">
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a137') }}</div>
                    </Col>
                    <Col flex="1" >
                        <i-switch class="switch-cls" size="large" :true-value="1" :false-value="0"></i-switch>
                    </Col>
                </Row>
                </Col>
            </Row>
        </Card>
        </Col>        

        <Col flex="1" >
        <Card class="card-container" dis-hover>
            <div slot="title" class="card-title">{{ getTranslation('a142') }}</div>
            <Row type="flex" class="normal-hover multi-row">
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a143') }}</div>
                    </Col>
                    <Col flex="1" >
                        <i-switch class="switch-cls" size="large" :true-value="1" :false-value="0" v-model="HwAssy1bit11"></i-switch>
                    </Col>
                </Row>
                </Col>
            </Row>
             <Row type="flex" class="normal-hover multi-row">
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a144') }}</div>
                    </Col>
                    <Col flex="1" >
                        <i-switch class="switch-cls" size="large" :true-value="1" :false-value="0" v-model="HwAssy1bit12"></i-switch>
                    </Col>
                </Row>
                </Col>
            </Row>
             <Row type="flex" class="normal-hover multi-row">
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a145') }}</div>
                    </Col>
                    <Col flex="1" >
                        <i-switch class="switch-cls" size="large" :true-value="1" :false-value="0" v-model="HwAssy0bit5"></i-switch>
                    </Col>
                </Row>
                </Col>
            </Row>
        </Card>
        </Col>

        <Col flex="1" >
        <Card class="card-container" dis-hover>
            <div slot="title" class="card-title">{{ getTranslation('a146') }}</div>
            <Row type="flex" class="normal-hover ">
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a147') }}</div>
                    </Col>
                    <Col flex="1" >
                        <i-switch class="switch-cls" size="large" :true-value="1" :false-value="0" v-model="HwPosSwbit0"></i-switch>
                    </Col>
                </Row>
                </Col>
            </Row>
             <Row type="flex" class="normal-hover multi-row">
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a148') }}</div>
                    </Col>
                    <Col flex="1" >
                        <i-switch class="switch-cls" size="large" :true-value="1" :false-value="0" v-model="HwPosSwbit1"></i-switch>
                    </Col>
                </Row>
                </Col>
            </Row>
            <Row type="flex" class="normal-hover multi-row">
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a149') }}</div>
                    </Col>
                    <Col flex="1" >
                        <i-switch class="switch-cls" size="large" :true-value="1" :false-value="0" v-model="HwPosSwbit2"></i-switch>
                    </Col>
                </Row>
                </Col>
            </Row>
            <Row type="flex" class="normal-hover multi-row">
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a150') }}</div>
                    </Col>
                    <Col flex="1" >
                        <i-switch class="switch-cls" size="large" :true-value="1" :false-value="0" v-model="HwPosSwbit3"></i-switch>
                    </Col>
                </Row>
                </Col>
            </Row>
        </Card>
        </Col>

        <Col flex="1" >
        <Card class="card-container" dis-hover>
            <div slot="title" class="card-title">{{ getTranslation('a151') }}</div>
            <Row type="flex" class="normal-hover multi-row">
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a152') }}</div>
                    </Col>
                    <Col flex="1" >
                        <i-switch class="switch-cls" size="large" :true-value="1" :false-value="0"></i-switch>
                    </Col>
                </Row>
                </Col>
            </Row>
            <Row type="flex" class="normal-hover multi-row">
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a153') }}</div>
                    </Col>
                    <Col flex="1" >
                        <i-switch class="switch-cls" size="large" :true-value="1" :false-value="0"></i-switch>
                    </Col>
                </Row>
                </Col>
            </Row>
            <Row type="flex" class="normal-hover multi-row">
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a154') }}</div>
                    </Col>
                    <Col flex="1" >
                        <i-switch class="switch-cls" size="large" :true-value="1" :false-value="0"></i-switch>
                    </Col>
                </Row>
                </Col>
            </Row>
            <Row type="flex" class="normal-hover multi-row">
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a155') }}</div>
                    </Col>
                    <Col flex="1" >
                        <Select :transfer="true" class="input-field" size="small" v-model="localData.HwE1PrsSnsType"
                        :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                        <Option v-for="(item, key) in PrsSnsTypeList" :value="key" :key="key">{{ item }}</Option>
                        </Select>                      
                    </Col>
                </Row>
                </Col>
            </Row>
        </Card>
        </Col>


    </Row>
    <Row type="flex">
         <Col flex="1" >
        <Card class="card-container" dis-hover>
            <div slot="title" class="card-title">{{ getTranslation('a160') }}</div>
            <Row type="flex" class="normal-hover ">
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a161') }}</div>
                    </Col>
                    <Col flex="1" >
                        <i-switch class="switch-cls" size="large" :true-value="1" :false-value="0" v-model="HwAssy1bit2"></i-switch>
                    </Col>
                </Row>
                </Col>
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a162') }}</div>
                    </Col>
                    <Col flex="1" >
                        <i-switch class="switch-cls" size="large" :true-value="1" :false-value="0" v-model="HwAssy1bit3"></i-switch>
                    </Col>
                </Row>
                </Col>
            </Row>
             <Row type="flex" class="normal-hover multi-row">
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a163') }}</div>
                    </Col>
                    <Col flex="1" >
                        <Select :transfer="true" class="input-field" size="small" v-model="HwConvType8"
                        :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                        <Option v-for="(item, key) in HwConvTypeMatList" :value="key" :key="key">{{ item }}</Option>
                        </Select>                          
                    </Col>
                </Row>
                </Col>
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a163') }}</div>
                    </Col>
                    <Col flex="1" >
                        <Select :transfer="true" class="input-field" size="small" v-model="HwConvType9"
                        :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                        <Option v-for="(item, key) in HwConvTypeMatList" :value="key" :key="key">{{ item }}</Option>
                        </Select> 
                    </Col>
                </Row>
                </Col>
            </Row>
            <Row type="flex" class="normal-hover multi-row">
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a164') }}</div>
                    </Col>
                    <Col flex="1" >
                        <Select :transfer="true" class="input-field" size="small" v-model="HwConvType4"
                        :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                        <Option v-for="(item, key) in HwConvTypeDirList" :value="key" :key="key">{{ item }}</Option>
                        </Select> 
                    </Col>
                </Row>
                </Col>
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a164') }}</div>
                    </Col>
                    <Col flex="1" >
                        <Select :transfer="true" class="input-field" size="small" v-model="HwConvType5"
                        :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                        <Option v-for="(item, key) in HwConvTypeDirList" :value="key" :key="key">{{ item }}</Option>
                        </Select> 
                    </Col>
                </Row>
                </Col>
            </Row>
            <Row type="flex" class="normal-hover multi-row">
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a165') }}</div>
                    </Col>
                    <Col flex="1" >
                        <Select :transfer="true" class="input-field" size="small" v-model="HwConvType0"
                        :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                        <Option v-for="(item, key) in HwConvTypeList" :value="key" :key="key">{{ item }}</Option>
                        </Select>
                    </Col>
                </Row>
                </Col>
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a165') }}</div>
                    </Col>
                    <Col flex="1" >
                        <Select :transfer="true" class="input-field" size="small" v-model="HwConvType1"
                        :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                        <Option v-for="(item, key) in HwConvTypeList" :value="key" :key="key">{{ item }}</Option>
                        </Select>
                    </Col>
                </Row>
                </Col>
            </Row>
        </Card>
        </Col>
         <Col flex="1" >
        <Card class="card-container" dis-hover>
            <div slot="title" class="card-title">{{ getTranslation('a166') }}</div>
            <Row type="flex" class="normal-hover ">
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a167') }}</div>
                    </Col>
                    <Col flex="1" >
                        <Select :transfer="true" class="input-field" size="small" v-model="localData.HwWeldCtrlType"
                        :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                        <Option v-for="(item, key) in WeldCtrlTypeList" :value="key" :key="key">{{ item }}</Option>
                        </Select>
                    </Col>
                </Row>
               
                </Col>
            </Row>
             <Row type="flex" class="normal-hover multi-row">
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a168') }}</div>
                    </Col>
                    <Col flex="1" >
                        <Select :transfer="true" class="input-field" size="small" v-model="localData.HwWeldCtrlIf"
                        :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                        <Option v-for="(item, key) in WeldCtrlIfList" :value="key" :key="key">{{ item }}</Option>
                        </Select>
                    </Col>
                </Row>
                </Col>
                </Row>
         
        </Card>
        </Col>
         <Col flex="1" >
        </Col>

    </Row>
    <Row>
        <Button type="primary" @click="handleSave">{{ getTranslation('c006') }}</Button>
    </Row>
</div>
</template>

<script>
import {
    mapGetters
} from 'vuex'
import { int16toBit, bitToInt16 } from '@/util/util'


export default {
    name: 'HareWare',
    components: {},
    props: {
        systemData: {
            type: Object,
            default: function() { return {} }
        },
        mac: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            // 需要按位编辑的字段列表，后续新增字段只需追加到此数组
            bitFields: ['HwAssy0','HwAssy1','HwPosSw','HwConvType'],
            // 原始值快照，保存时对比用
            originalData: {},
            // { HwAssy0: [0,1,0,...], HwAssy1: [...] }
            localBitsMap: {},
            // 需要本地副本的普通值字段（避免直接修改 prop），后续新增字段只需追加到此数组
            valueFields: ['HwValveTypePrePrs', 'HwValveTypeTrip','HwE1PropValveType','HwE1PrsSnsType','HwWeldCtrlType','HwWeldCtrlIf'],
            // 本地值副本 { HwValveTypePrePrs: val, hwValveTypeTrip: val }
            localData: {}
        }
    },
    computed: {
        ...mapGetters(['getTranslation']),
        HwAssy0bit0: {
            get: function() { var b = this.localBitsMap['HwAssy0']; return b ? b[0] : 0 },
            set: function(val) { var b = this.localBitsMap['HwAssy0']; if (b) this.$set(b, 0, val ? 1 : 0) }
        },
        HwAssy0bit1: {
            get: function() { var b = this.localBitsMap['HwAssy0']; return b ? b[1] : 0 },
            set: function(val) { var b = this.localBitsMap['HwAssy0']; if (b) this.$set(b, 1, val ? 1 : 0) }
        },
        HwAssy0bit2: {
            get: function() { var b = this.localBitsMap['HwAssy0']; return b ? b[2] : 0 },
            set: function(val) { var b = this.localBitsMap['HwAssy0']; if (b) this.$set(b, 2, val ? 1 : 0) }
        },
        HwAssy0bit4: {
            get: function() { var b = this.localBitsMap['HwAssy0']; return b ? b[4] : 0 },
            set: function(val) { var b = this.localBitsMap['HwAssy0']; if (b) this.$set(b, 4, val ? 1 : 0) }
        },
        HwAssy0bit5: {
            get: function() { var b = this.localBitsMap['HwAssy0']; return b ? b[5] : 0 },
            set: function(val) { var b = this.localBitsMap['HwAssy0']; if (b) this.$set(b, 5, val ? 1 : 0) }
        },
        HwAssy0bit6: {
            get: function() { var b = this.localBitsMap['HwAssy0']; return b ? b[6] : 0 },
            set: function(val) { var b = this.localBitsMap['HwAssy0']; if (b) this.$set(b, 6, val ? 1 : 0) }
        },
        HwAssy0bit9: {
            get: function() { var b = this.localBitsMap['HwAssy0']; return b ? b[9] : 0 },
            set: function(val) { var b = this.localBitsMap['HwAssy0']; if (b) this.$set(b, 9, val ? 1 : 0) }
        },
        HwAssy1bit2:{
            get: function() { var b = this.localBitsMap['HwAssy1']; return b ? b[2] : 0 },
            set: function(val) { var b = this.localBitsMap['HwAssy1']; if (b) this.$set(b, 2, val ? 1 : 0) }        
        },
        HwAssy1bit3:{
            get: function() { var b = this.localBitsMap['HwAssy1']; return b ? b[3] : 0 },
            set: function(val) { var b = this.localBitsMap['HwAssy1']; if (b) this.$set(b, 3, val ? 1 : 0) }        
        },
        HwAssy1bit10:{
            get: function() { var b = this.localBitsMap['HwAssy1']; return b ? b[10] : 0 },
            set: function(val) { var b = this.localBitsMap['HwAssy1']; if (b) this.$set(b, 10, val ? 1 : 0) }        
        },
        HwAssy1bit11:{
            get: function() { var b = this.localBitsMap['HwAssy1']; return b ? b[11] : 0 },
            set: function(val) { var b = this.localBitsMap['HwAssy1']; if (b) this.$set(b, 11, val ? 1 : 0) }        
        },
        HwAssy1bit12:{
            get: function() { var b = this.localBitsMap['HwAssy1']; return b ? b[12] : 0 },
            set: function(val) { var b = this.localBitsMap['HwAssy1']; if (b) this.$set(b, 12, val ? 1 : 0) }        
        },
        HwAssy1bit13: {
            get: function() { var b = this.localBitsMap['HwAssy1']; return b ? b[13] : 0 },
            set: function(val) { var b = this.localBitsMap['HwAssy1']; if (b) this.$set(b, 13, val ? 1 : 0) }
        },
        HwAssy1bit14: {
            get: function() { var b = this.localBitsMap['HwAssy1']; return b ? b[14] : 0 },
            set: function(val) { var b = this.localBitsMap['HwAssy1']; if (b) this.$set(b, 14, val ? 1 : 0) }
        },
        HwAssy1bit15: {
            get: function() { var b = this.localBitsMap['HwAssy1']; return b ? b[15] : 0 },
            set: function(val) { var b = this.localBitsMap['HwAssy1']; if (b) this.$set(b, 15, val ? 1 : 0) }
        },
        HwPosSwbit0: {
            get: function() { var b = this.localBitsMap['HwPosSw']; return b ? b[0] : 0 },
            set: function(val) { var b = this.localBitsMap['HwPosSw']; if (b) this.$set(b, 0, val ? 1 : 0) }
        },
        HwPosSwbit1: {
            get: function() { var b = this.localBitsMap['HwPosSw']; return b ? b[1] : 0 },
            set: function(val) { var b = this.localBitsMap['HwPosSw']; if (b) this.$set(b, 1, val ? 1 : 0) }
        },
        HwPosSwbit2: {
            get: function() { var b = this.localBitsMap['HwPosSw']; return b ? b[2] : 0 },
            set: function(val) { var b = this.localBitsMap['HwPosSw']; if (b) this.$set(b, 2, val ? 1 : 0) }
        },
        HwPosSwbit3: {
            get: function() { var b = this.localBitsMap['HwPosSw']; return b ? b[3] : 0 },
            set: function(val) { var b = this.localBitsMap['HwPosSw']; if (b) this.$set(b, 3, val ? 1 : 0) }
        },
        HwPosSwbit4: {
            get: function() { var b = this.localBitsMap['HwPosSw']; return b ? b[4] : 0 },
            set: function(val) { var b = this.localBitsMap['HwPosSw']; if (b) this.$set(b, 4, val ? 1 : 0) }
        },
        HwPosSwbit5: {
            get: function() { var b = this.localBitsMap['HwPosSw']; return b ? b[5] : 0 },
            set: function(val) { var b = this.localBitsMap['HwPosSw']; if (b) this.$set(b, 5, val ? 1 : 0) }
        },
        HwConvType0: {
            get: function() { var b = this.localBitsMap['HwConvType']; return b ? b[0] : 0 },
            set: function(val) { var b = this.localBitsMap['HwConvType']; if (b) this.$set(b, 0, val ? 1 : 0) }
        },
        HwConvType1: {
            get: function() { var b = this.localBitsMap['HwConvType']; return b ? b[1] : 0 },
            set: function(val) { var b = this.localBitsMap['HwConvType']; if (b) this.$set(b, 1, val ? 1 : 0) }
        },
        HwConvType4: {
            get: function() { var b = this.localBitsMap['HwConvType']; return b ? b[4] : 0 },
            set: function(val) { var b = this.localBitsMap['HwConvType']; if (b) this.$set(b, 4, val ? 1 : 0) }
        },
        HwConvType5: {
            get: function() { var b = this.localBitsMap['HwConvType']; return b ? b[5] : 0 },
            set: function(val) { var b = this.localBitsMap['HwConvType']; if (b) this.$set(b, 5, val ? 1 : 0) }
        },
        HwConvType8: {
            get: function() { var b = this.localBitsMap['HwConvType']; return b ? b[8] : 0 },
            set: function(val) { var b = this.localBitsMap['HwConvType']; if (b) this.$set(b, 8, val ? 1 : 0) }
        },
        HwConvType9: {
            get: function() { var b = this.localBitsMap['HwConvType']; return b ? b[9] : 0 },
            set: function(val) { var b = this.localBitsMap['HwConvType']; if (b) this.$set(b, 9, val ? 1 : 0) }
        },
       
        PropValveTypeLisdt(){
            return [
                this.getTranslation('a138'),
                this.getTranslation('a139'),
                this.getTranslation('a140')
            ]
        },
        ValveTypePrePrsList(){
            return [
                this.getTranslation('k372'),
                this.getTranslation('k373'),
            ]
        },
        PrsSnsTypeList(){
             return [
                this.getTranslation('a156'),
                this.getTranslation('a157'),
                this.getTranslation('a158'),
            ]
        },
        HwConvTypeList(){
             return [
                this.getTranslation('a169'),
                this.getTranslation('a170'),
            ]
        },
        HwConvTypeDirList(){
             return [
                this.getTranslation('a171'),
                this.getTranslation('a172'),
            ]
        },
        HwConvTypeMatList(){
             return [
                this.getTranslation('a173'),
                this.getTranslation('a174'),
            ]
        },
        WeldCtrlTypeList(){
            return [
                "HRC803",
                "HRC805",
            ]
        },
        WeldCtrlIfList(){
            return [
                this.getTranslation('a175'),
                this.getTranslation('a176'),
            ]
        }
        
    },
    created() {
        var self = this
        this.bitFields.forEach(function(field) {
            self.$watch('systemData.' + field, function(newVal) {
                if (newVal != null) {
                    self.$set(self.localBitsMap, field, int16toBit(newVal))
                    self.$set(self.originalData, field, newVal)
                }
            }, { immediate: true })
        })
        this.valueFields.forEach(function(field) {
            self.$watch('systemData.' + field, function(newVal) {
                self.$set(self.localData, field, newVal)
                self.$set(self.originalData, field, newVal)
            }, { immediate: true })
        })
    },
    methods: {
        handleSave() {
            var payload = {}
            var self = this
            this.bitFields.forEach(function(field) {
                var bits = self.localBitsMap[field]
                if (!bits) return
                var newVal = bitToInt16(bits)
                if (newVal !== self.originalData[field]) {
                    payload[field] = newVal
                }
            })
            this.valueFields.forEach(function(field) {
                var newVal = self.localData[field]
                if (newVal != null && newVal !== self.originalData[field]) {
                    payload[field] = newVal
                }
            })
            if (Object.keys(payload).length > 0) {
                this.$emit('save', payload)
            }else {
                 this.$Message.error(this.getTranslation('a159'))
            }
        }
    },
}
</script>

<style scoped>
@import url('../../../../assets/style/list.css');
@import url('../../../../assets/style/tab.css');
.multi-row{
    margin-top:10px;
}

</style>
